export type SupplierPublicVisibility = "hidden" | "brand-visible" | "manufacturer-visible";
export type SupplierCrawlStatus = "successful" | "partial" | "inaccessible";

export type Supplier = {
  id: string;
  name: string;
  website: string;
  sector: string;
  publicVisibility: SupplierPublicVisibility;
  relationshipStatus: "network-access";
  crawlStatus: SupplierCrawlStatus;
  notes: string;
};

export const suppliers: Supplier[] = [
  {
    id: "atavita",
    name: "Atavita",
    website: "https://www.atavita.com/",
    sector: "Agriculture & Fresh Produce",
    publicVisibility: "brand-visible",
    relationshipStatus: "network-access",
    crawlStatus: "successful",
    notes: "Official category and individual product pages verified on 2026-08-30.",
  },
  {
    id: "afa-steel",
    name: "AFA Steel",
    website: "https://afasteel.com/",
    sector: "Steel & Metals",
    publicVisibility: "hidden",
    relationshipStatus: "network-access",
    crawlStatus: "successful",
    notes: "Official rebar listings and billet category verified; live prices deliberately excluded.",
  },
  {
    id: "zafar-steel",
    name: "Zafar Steel",
    website: "https://zafarsteel.ir/",
    sector: "Steel & Metals",
    publicVisibility: "hidden",
    relationshipStatus: "network-access",
    crawlStatus: "successful",
    notes: "Four official product pages verified on the current site.",
  },
  {
    id: "part-gowal",
    name: "Part Gowal",
    website: "https://partgowal.com/",
    sector: "Minerals & Ferroalloys",
    publicVisibility: "hidden",
    relationshipStatus: "network-access",
    crawlStatus: "successful",
    notes: "English product sections and individual product anchors verified.",
  },
  {
    id: "navid-motor",
    name: "Navid Motor",
    website: "https://navidmotor.com/",
    sector: "Pumps & Industrial Equipment",
    publicVisibility: "brand-visible",
    relationshipStatus: "network-access",
    crawlStatus: "successful",
    notes: "Official product and category pages verified; marketing superlatives were not retained.",
  },
  {
    id: "navid-sahand-pump",
    name: "Navid Sahand Pump",
    website: "https://navidsahandpump.com/",
    sector: "Pumps & Industrial Equipment",
    publicVisibility: "brand-visible",
    relationshipStatus: "network-access",
    crawlStatus: "partial",
    notes: "Official product URLs were indexed, but live product-page requests returned 403 during verification. Records remain non-public.",
  },
  {
    id: "pumpiran",
    name: "Pumpiran",
    website: "https://pumpiran.co/",
    sector: "Pumps & Industrial Equipment",
    publicVisibility: "brand-visible",
    relationshipStatus: "network-access",
    crawlStatus: "successful",
    notes: "Official English site and General Catalogue pages 1–40 verified.",
  },
];

const suppliersById = new Map(suppliers.map((supplier) => [supplier.id, supplier]));

export function getSupplier(id: string) {
  return suppliersById.get(id);
}
